import Vue from "vue";

export async function link() {
  const response = await Vue.prototype.$http.get(`/pulse/link`);

  return response.data;
}
